import axios from 'axios';

const instance = axios.create({
    baseURL: 'http://192.168.1.52:8081/burned_areas_react/burned_areas_react_api/',
    crossDomain: true,
    withCredentials: false,
    //credentials: 'same-origin',
    //mode: 'no-cors',
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }
});

export default instance;